import { getUserFields } from "components/user/config";
import { updateItemInCollection } from "directus/src/operations";

export async function updateOpening({ openingId, item }) {
    try {
        const query = {
            fields: [
                "id",
                "title",
                "description",
                "status",
                "expertise",
                "opportunity_link",
                "sales_coordinator",
                "skills"
            ],
        };

        const data = await updateItemInCollection(
            "openings",
            openingId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
